export const externalIntegrationConnectStoreNameField = 'storeName'

export type ExternalIntegrationConnectFormScheme = {
  [externalIntegrationConnectStoreNameField]: string
}
